// react
import { createContext, Dispatch, SetStateAction } from 'react';

// types
import { Document, Entity, Pagination, Transaction, User } from '../../../@types';

// defaults
import { defaultPagination } from '../../../utils/defaults';

// beneficiary
export interface ContextBeneficiaryProps {
	beneficiary: Entity | null;
	isLoadingBeneficiary: boolean;
	refetchBeneficiary: () => void;
	setBeneficiary: Dispatch<SetStateAction<Entity | null>>;
}

export const ContextBeneficiary = createContext<ContextBeneficiaryProps>({
	beneficiary: null,
	isLoadingBeneficiary: false,
	refetchBeneficiary: () => {
		console.log('REFETCH BENEFICIARY');
	},
	setBeneficiary: () => {
		console.log('SET BENEFICIARY');
	},
});

// documents
export interface ContextBeneficiaryDocumentsProps {
	documents: Document[];
	isLoadingDocuments: boolean;
	paginationDocuments: Pagination;
	refetchDocuments: () => void;
	setDocuments: Dispatch<SetStateAction<Document[]>>;
	setPaginationDocuments: Dispatch<SetStateAction<Pagination>>;
}

export const ContextBeneficiaryDocuments = createContext<ContextBeneficiaryDocumentsProps>({
	documents: [],
	isLoadingDocuments: false,
	paginationDocuments: defaultPagination,
	refetchDocuments: () => {
		console.log('REFETCH DOCUMENTS');
	},
	setDocuments: () => {
		console.log('SET DOCUMENTS');
	},
	setPaginationDocuments: () => {
		console.log('SET PAGINATION');
	},
});

// cash benefits
export interface ContextBeneficiaryCashBenefitsProps {
	cashBenefits: Transaction[];
	isLoadingCashBenefits: boolean;
	paginationCashBenefits: Pagination;
	refetchCashBenefits: () => void;
	setCashBenefits: Dispatch<SetStateAction<Transaction[]>>;
	setPaginationCashBenefits: Dispatch<SetStateAction<Pagination>>;
}

export const ContextBeneficiaryCashBenefits = createContext<ContextBeneficiaryCashBenefitsProps>({
	cashBenefits: [],
	isLoadingCashBenefits: false,
	paginationCashBenefits: defaultPagination,
	refetchCashBenefits: () => {
		console.log('REFETCH CASHBENEFITS');
	},
	setCashBenefits: () => {
		console.log('SET CASHBENEFITS');
	},
	setPaginationCashBenefits: () => {
		console.log('SET PAGINATION');
	},
});

// non cash benefits
export interface ContextBeneficiaryNonCashBenefitsProps {
	isLoadingNonCashBenefits: boolean;
	nonCashBenefits: Transaction[];
	paginationNonCashBenefits: Pagination;
	refetchNonCashBenefits: () => void;
	setNonCashBenefits: Dispatch<SetStateAction<Transaction[]>>;
	setPaginationNonCashBenefits: Dispatch<SetStateAction<Pagination>>;
}

export const ContextBeneficiaryNonCashBenefits =
	createContext<ContextBeneficiaryNonCashBenefitsProps>({
		isLoadingNonCashBenefits: false,
		nonCashBenefits: [],
		paginationNonCashBenefits: defaultPagination,
		refetchNonCashBenefits: () => {
			console.log('REFETCH NONCASHBENEFITS');
		},
		setNonCashBenefits: () => {
			console.log('SET NONCASHBENEFITS');
		},
		setPaginationNonCashBenefits: () => {
			console.log('SET PAGINATION');
		},
	});

// users
export interface ContextBeneficiaryUsersProps {
	isLoadingUsers: boolean;
	paginationUsers: Pagination;
	refetchUsers: () => void;
	setPaginationUsers: Dispatch<SetStateAction<Pagination>>;
	setUsers: Dispatch<SetStateAction<User[]>>;
	users: User[];
}

export const ContextBeneficiaryUsers = createContext<ContextBeneficiaryUsersProps>({
	isLoadingUsers: false,
	paginationUsers: defaultPagination,
	refetchUsers: () => {
		console.log('REFETCH USERS');
	},
	setPaginationUsers: () => {
		console.log('SET PAGINATION');
	},
	setUsers: () => {
		console.log('SET USERS');
	},
	users: [],
});
